import { MantineTextInput } from '@dealstack/frontend/shared/components/mantineForm/MantineTextInput.tsx';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Button, Flex } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { TEST_ELEMENT_IDS } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier.tsx';
import {
	CREATE_PERSON_LEGAL_FORM_VALUES,
	useCreatePersonLegalController,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageSidebar/CreatePersonTabs/CreatePersonLegal/useCreatePersonLegalController.ts';

interface Props {
	onCreateSuccess: (createdEntityId: string, withClose?: boolean) => void;
	dealId: string;
	setComputedName: (name: string) => void;
}

export const CreatePersonLegal = ({ onCreateSuccess, dealId, setComputedName }: Props) => {
	const { createPersonLegalForm, onSubmit, isLoading } = useCreatePersonLegalController(
		onCreateSuccess,
		dealId,
		setComputedName
	);
	const tCapManage = useTranslationCapManage();

	const handleSubmitAndClose = createPersonLegalForm.handleSubmit((data) =>
		onSubmit(data, false)
	);

	const handleSubmitAndReset = createPersonLegalForm.handleSubmit((data) => onSubmit(data, true));

	return (
		<FormProvider {...createPersonLegalForm}>
			{isLoading && <InlineLoader />}
			<form onSubmit={handleSubmitAndClose}>
				<MantineTextInput
					data-testid={TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON_NAME_INPUT}
					autoFocus
					size="md"
					placeholder={tCapManage(
						'sidebar.create_entity_box.organisation_form.name_label'
					)}
					name={CREATE_PERSON_LEGAL_FORM_VALUES.NAME}
				/>

				<Flex gap="0.5rem" mt="1rem">
					<Button
						data-testid={
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON_SUBMIT_BUTTON
						}
						size="md"
						type="submit"
						style={{ flex: 1 }}
					>
						{tCapManage(
							'sidebar.create_entity_box.organisation_form.submit_button_text'
						)}
					</Button>
					<Button variant="default" style={{ flex: 1 }} onClick={handleSubmitAndReset}>
						{tCapManage(
							'sidebar.create_entity_box.organisation_form.add_another_button_text'
						)}
					</Button>
				</Flex>
			</form>
		</FormProvider>
	);
};
